<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-plant name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <c-text
            :afterIcon="[
              { name: 'search', click: true, callbackName: 'searchEduMaster', color: 'teal' },
              { name: 'close', click: true, callbackName: 'removeEduMaster', color: 'red' }
            ]"
            :readonly="true"
            :editable="editable"
            label="교육과정"
            name="educationCourseName"
            @searchEduMaster="searchEduMaster"
            @removeEduMaster="removeEduMaster"
            v-model="searchParam.educationCourseName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
          <!-- 점검일 -->
          <c-datepicker
            :range="true"
            name="period"
            defaultStart="-6M"
            defaultEnd="6M"
            :isToyear="true"
            label="교육기간"
            v-model="period"
          ></c-datepicker>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="교육별 대상자 목록"
      tableId="table"
      :columns="grid.columns"
      :data="grid.data"
      :editable="false"
      :merge="grid.merge"
      checkDisableColumn="disable"
      :checkClickFlag="false"
      rowKey="eduEducationId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <div>
          <q-btn-group outline>
            <c-btn v-show="editable" label="대상자 연명부" icon="print" @btnClicked="btnPrint" />
            <c-btn label="검색" icon="search" @btnClicked="getList" />
          </q-btn-group>
        </div>
      </template>
      
        <template v-slot:customArea="{ props, col }">
          <template v-if="col.name === 'click'">
            <q-btn 
              round unelevated 
              size="10px"
              color="amber" 
              icon="search"
              @click.stop="() => { rowIndex = props.rowIndex, electronSignature = props.row.electronSignature}"
              >
              <q-popup-proxy :ref="'proxy1_' + props.rowIndex" :breakpoint="400">
                <component
                  :is="col.component"
                  :popupParam="props.row"
                  :rowIndex="props.rowIndex"
                  @callback="callback1"
                />
              </q-popup-proxy>
            </q-btn>
          </template>
        </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "education-target-users",
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'eduMergeGroup' },
          { index: 1, colName: 'eduMergeGroup' },
          { index: 2, colName: 'eduMergeGroup' },
        ],
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:80px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationCourseName",
            field: "educationCourseName",
            label: "교육과정",
            style: 'width:200px',
            align: "center",
            sortable: true,
          },
          {
            name: "educationName",
            field: "educationName",
            label: "교육명",
            align: "left",
            sortable: true,
            type: "link",
          },
          {
            name: 'attendeesDeptName',
            field: 'attendeesDeptName',
            style: 'width:80px',
            label: '부서',
            align: 'center',
            sortable: false,
          },
          {
            name: 'attendeesName',
            field: 'attendeesName',
            label: '대상자명',
            style: 'width:100px',
            align: 'center',
            sortable: false
          },
          {
            name: 'click',
            field: 'click',
            label: '서명보기',
            style: 'width:70px',
            type: 'custom',
            align: 'center',
            sortable: false,
            component: () => import(`${'@/pages/sop/edu/result/signaturePop.vue'}`)
          },
          {
            name: 'evaluationPoint',
            field: 'evaluationPoint',
            label: '평가점수',
            style: 'width:100px',
            align: 'center',
            sortable: false
          },
          {
            name: 'evaluationContent',
            field: 'evaluationContent',
            label: '평가내용',
            style: 'width:220px',
            align: 'center',
            sortable: false
          },
          {
            name: 'evaluationDate',
            field: 'evaluationDate',
            setHeader: true,
            label: '이수일',
            style: 'width:110px',
            align: 'center',
            sortable: false
          },
          {
            name: 'noAttendanceReason',
            field: 'noAttendanceReason',
            label: '불참사유',
            style: 'width:200px',
            align: 'left',
            sortable: false
          },
          {
            name: 'attach',
            field: 'attach',
            label: '첨부파일',
            align: 'center',
            style: 'width:200px',
            type: 'attach',
            taskClassCd: 'EDU_RESULT_COMPLETE',
            keyText: 'attendeesNo',
            sortable: false,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        startYmd: '',
        endYmd: '',
        educationCourseName: '',
        eduCourseId: '',
      },
      period: [],
      editable: true,
      popupOptions: {
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      listUrl: "",
      printUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.edu.target.users.url;
      this.printUrl = selectConfig.sop.edu.result.print.third.url;
      
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      if (this.period) {
        this.searchParam.startYmd = this.period[0];
        this.searchParam.endYmd = this.period[1];
      } else {
        this.searchParam.startYmd = '';
        this.searchParam.endYmd = '';
      }

      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "교육계획 및 결과 상세"; // 교육계획 상세
      this.popupOptions.param = {
        eduEducationId: row.eduEducationId ? row.eduEducationId : '',
        stepCd: row.documentStatusCd === 'ESC000001' ?  'ESC0000005' : 'ESC0000010',
      };
      this.popupOptions.target = () =>
        import(`${"@/pages/sop/edu/result/educationResultDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    searchEduMaster() {
      this.popupOptions.title = '교육과정 검색'; // 교육과정 검색
      this.popupOptions.param = {
        type: 'single',
        plantCd: this.searchParam.plantCd,
      };
      this.popupOptions.target = () => import(`${'@/pages/sop/edu/educationCurriculumnPop.vue'}`);
      this.popupOptions.width = '95%';
      this.popupOptions.isFull = false;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeEduCoursePopup;
    },
    closeEduCoursePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data.selectData && data.selectData.length > 0) {
        this.searchParam.eduCourseId = data.selectData[0].eduCourseId
        this.searchParam.educationCourseName = data.selectData[0].educationCourseName
      }
    },
    removeEduMaster() {
      this.searchParam.eduCourseId = '';
      this.searchParam.educationCourseName = '';
    },
    btnPrint() {
      if (!this.searchParam.eduCourseId) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '검색조건에서 교육과정을 선택하세요.',
          type: 'warning', // success / info / warning / error
        });
        return;
      } 
      let thisVue = this;
      this.$http.url = this.printUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request(
        _result => {
          let fileOrgNm = this.searchParam.educationCourseName + ' 연명부.docx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    },
    callback1(data, rowIndex) {
      let refName = 'proxy1_' + rowIndex;
      this.$refs[refName].hide();
    },
  },
};
</script>
